<template>
  <div>
    <div class="messages-desc">
      <span v-html="$t('campaigns.sampleMessageDesc1')"></span>
      <span v-html="$t('campaigns.sampleMessageDesc2')"></span>
      <span v-html="$t('campaigns.sampleMessageDesc3')"></span>
    </div>
    <div v-if="!!errors.sample1 && messages.length === 0" class="Vlt-red-dark Vlt-margin--A-bottom2">
      {{ errors.sample1 }}
    </div>
    <div>
      <div v-for="(message, index) in messages" :key="index" class="input-and-button">
        <text-field data-cy="sms-registration-sample-message-input" class = "sample-message-input" :id="`sample${index}`" :label="$t(`campaigns.sample${index + 1}`)"
                    @textChanged="val=>handleTextChange(val,index)" :validation-message="sampleMessagesErrorMessage" :value="message"
                    :pattern="sampleMessageLengthRegex" :readOnly="readOnly"/>
        <div class="input-and-button__button">
          <cd-button
            v-if="index + 1 > unremovable"
            :id="`sample${index}_deleteBtn`"
            icon="delete-line"
            :disabled="readOnly || (messages.length <= sampleMessagesMin && index < sampleMessagesMin) || index + 1 <= unremovable"
            layout="text"
            connotation="alert"
            class="tendlc-icon-only"
            @click="remove(index)"
          />
        </div>
      </div>
      <div class="add-button">
        <cd-button
          icon="add-line"
          :label="$t('campaigns.addSampleMessage')"
          :disabled="readOnly || maxed"
          layout="text"
          connotation="cta"
          @click="next"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { CdButton } from '../atomicUIComponents';
  import TextField from "../VwcTextField";

  const MESSAGES_LIMIT = 5;
  const sampleMessageLengthRegex = '^.{20,1023}$';

  export default {
    name: 'SampleMessages',

    components: {
      CdButton,
      TextField,
    },

    props: {
      readOnly: {
        type: Boolean,
        default: false,
      },
      errors: {
        type: Object,
        default: () => ({}),
      },
      value: {
        type: Object,
        default: () => ({
          sample1: '',
        }),
      },
      unremovable: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        messages: [''],
        sampleMessageLengthRegex,
      };
    },

    computed: {
      maxed() {
        return this.messages.length === MESSAGES_LIMIT;
      },
      ...mapState('campaigns', ['sampleMessagesMin']),
      sampleMessagesErrorMessage() {
        return this.$t('smsRegistrations.minLengthSampleMessages');
      },
    },

    watch: {
      sampleMessagesMin(val) {
        const addition = val - this.messages.length;
        if (addition > 0) {
          this.messages = [...this.messages, ...Array.apply('', Array(addition)).map(() => '')];
        }
      },
      messages: {
        deep: true,
        handler(val) {
          this.$emit(
            'input',
            val.reduce((acc, curr, index) => ({ ...acc, [`sample${index + 1}`]: curr }), {})
          );
        },
      },
    },

    mounted() {
      this.messages = Object.values(this.value);
    },

    methods: {
      next() {
        if (this.messages.length === MESSAGES_LIMIT) return;
        this.messages.push('');
      },
      remove(index) {
        this.messages = this.messages.filter((msg, i) => i !== index);
      },
      handleTextChange(val,index) {
        this.messages[index] = val;
        this.$emit(
            'input',
            this.messages.reduce((acc, curr, index) => ({ ...acc, [`sample${index + 1}`]: curr }), {})
        );
      }
    },
  };
</script>

<style lang="scss" scoped>
  .messages-desc {
    display: flex;
    flex-direction: column;
  }

  .sample-message-input {
    margin-top: 16px;
  }
  .input-and-button {
    display: flex;
    align-items: center;
    .Vlt-form__element {
      flex: 1;
    }
    .input-and-button__button {
      margin-top: 25px;
      margin-left: 8px;
    }
  }
</style>
<style lang="scss">
  .input-and-button__button vwc-button.tendlc-icon-only {
    width: 56px;
    overflow: hidden;
    border-radius: 8px;
  }
</style>
